import { combineReducers } from "redux";
import login from "./login";
import getjobs from "./get_jobs";
import getstoredata from "./getstoredata";
import completedJobs from "./get_completed_jobs";
import processingJobs from "./get_processing_jobs";
import orderDetails from "./get_ship_order";
import deliveryDetails from "./get_delivery_details";
import getpendingamount from "./get_pending_amount";
import getupdateStatus from "./get_update_status";
import getcompleteddetails from "./get_completed_details";
import getdelayreasons from "./get_delay_reasons";
import getholdreasons from "./get_hold_reasons";
import getdelayorders from "./get_delay_orders";
import returnReasons from "./get_return_reasons";
import reschedulereason from "./get_reschedule_reason";
import getnotifyreason from "./get_notify_reason";
import getCancelReasons from "./get_cancel_resons";
import intransitJob from "./get_intransit_job";
const rootReducer = combineReducers({
  login,
  getjobs,
  completedJobs,
  processingJobs,
  orderDetails,
  deliveryDetails,
  getstoredata,
  getupdateStatus,
  getpendingamount,
  getcompleteddetails,
  getdelayreasons,
  getholdreasons,
  getdelayorders,
  returnReasons,
  reschedulereason,
  getnotifyreason,
  getCancelReasons,
  intransitJob,
});
export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducer/index.js